const employeesData = [
  {
    id: 1,
    firstName: 'Thomas Vanegas',
    lastName: 'LSD62G',
    email: '70,000',
    salary: '2024-02-10',
    date: '2024-03-10',
  },
  {
    id: 2,
    firstName: 'Samuel Arroyave',
    lastName: 'EDA44G',
    email: '90,000',
    salary: '2024-02-29',
    date: '2024-03-29',
  },
  {
    id: 3,
    firstName: 'Mateo Monsalve',
    lastName: 'AKT34A',
    email: '80,000',
    salary: '2024-02-24',
    date: '2024-03-24',
  }
];

export { employeesData };
